import { web3 } from "utils/mintHelpers";
import type { Connector } from "../types";

const ETH_MAINNET = 1;

/**
 * Create digital signature using wallet provider
 */
const signRequestToVerifyIdentity = async (
  connector: Connector,
  address: string
): Promise<string> => {
  const { provider } = connector;
  if (!provider) {
    throw new Error("Wallet provider is not connected");
  }

  const providerChainId = await provider.request({ method: "eth_chainId" });

  // TODO - The value comes back as a hex 0x1 on coinbase mobile
  // and then the app crashes when we try to change the chain.
  if (
    providerChainId !== ETH_MAINNET &&
    providerChainId !== `0x${ETH_MAINNET}`
  ) {
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: web3.utils.toHex(ETH_MAINNET) }],
      });
    } catch (error) {
      // This error means the network hasn't been added yet
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any).code === 4902) {
        await provider.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainName: "Ethereum Mainnet",
              chainId: web3.utils.toHex(ETH_MAINNET),
            },
          ],
        });
      }
    }
  }

  const message =
    "Signing this message proves ownership of my wallet address to https://www.thehug.xyz and represents an agreement to our terms and conditions.";
  const data = `0x${Buffer.from(message, "utf-8").toString("hex")}`;

  const sign = await provider.request({
    method: "personal_sign",
    params: [data, address],
  });

  return sign as string;
};

export { signRequestToVerifyIdentity };
